export default "__VITE_ASSET__DlSTXTy9__"